<template lang="html">
<nav class="navbar navbar-expand-xl">
  <a class="navbar-brand">
    <picture v-if="session && session.session && session.session.app" >
      <img src="/media/pulse-new/app-icon.png" alt="logo">
    </picture>
    <span class="logo-name">{{ session && session.session && session.session.app ? session.session.app.name : '' }}</span>
  </a>
  <button class="navbar-toggler" type="button" @click="toggle" :class="{ open: expanded }"></button>
  <div class="collapse navbar-collapse" :class="{ show: expanded }">
    <a href="/policies/terms-of-service/">Terms of Services</a>
    <a href="/policies/privacy-policy/">Privacy policy</a>
    <a href="/policies/subscription-policy/">Subscription Terms</a>
    <a href="/policies/money-back-policy/">Money Back policy</a>
    <a href="/policies/cookie-policy/">Cookie policy</a>
    <a class="show-contact-form" href="#support">Contact us</a>
    <a id="cancelSubscription" href="#cancel-subscription" style="display:none">Cancel Subscription</a>
  </div>
</nav>
</template>

<script>
export default {
  data () {
    return {
      expanded: false,
      session: null
    }
  },
  mounted () {
    this.session = this.$parent.$refs.session
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded
    }
  }
}
</script>

<style lang="sass">
@import 'sass/nav.sass'

@media screen and (max-width: 700px)
  .navbar-toggler:not(.open)
    border-color: #000
    
    &:before, &:after
      background-color: #000

@media screen and (max-width: 700px)
  .navbar
    position: fixed
    background: transparent
    justify-content: space-between
    width: 100%
    z-index: 999

    .navbar-collapse
      position: absolute
      top: 70px
      height: 670px

    .navbar-brand
      padding: 18px 0 0 22px
      .logo-name
        display: none

    &:has(.navbar-collapse.show)
      background: #fff
      justify-content: space-between

      .navbar-brand
        display: flex
</style>
